import { createContext, useContext } from 'react';

export const DefaultAggregationConfig = {
  defaultAggregationId: undefined as string | undefined,
};

export const DefaultAggregationMethods = {
  setDefaultAggregationId: (_id: string | undefined) => {},
};

export const DefaultAggregationContextValue = {
  ...DefaultAggregationConfig,
  ...DefaultAggregationMethods,
};

export type DefaultAggregationContextProps = typeof DefaultAggregationContextValue;

export const DefaultAggregationContext = createContext<DefaultAggregationContextProps | undefined>(undefined);
DefaultAggregationContext.displayName = 'DefaultAggregationContext';

export function useDefaultAggregation() {
  const context = useContext(DefaultAggregationContext);
  if (context === undefined) {
    throw new Error('Missing DefaultAggregationContext.Provider further up in the tree.');
  }
  return context;
}
